import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchBankBranch } from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";

const { TextArea } = Input;

const AddStaffBankModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bankBranch, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ppId) {
      toast.error("Please select personnel");
      return;
    }
    if (!formData?.jbbCode) {
      toast.error("Please select bank");
      return;
    }
    if (!formData?.sbAccountno) {
      toast.error("Enter account No");
      return;
    }
    if (!formData?.sbPaypercent) {
      toast.error("Enter pay percentage");
      return;
    }
    const res = await dispatch(
      save({
        sbId: prodd?.sbId ? prodd?.sbId : null,
        ppId: formData?.ppId,
        jbbCode: formData?.jbbCode,
        sbAccountno: formData?.sbAccountno,
        sbPaypercent: formData?.sbPaypercent,
        url: "hr/saveStaffBank.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }
  async function fetchBankBranchData(page, size) {
    dispatch(fetchBankBranch());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.jbnkShtDesc}` : "Add staff bank details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Staff</span>}
            rules={[
              {
                required: true,
                message: "Please select staff",
              },
            ]}
          >
            <Select
              name="ppId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppPfno + " - " + item?.ppFullname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ppId");
              }}
              value={formData?.ppId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchPersonnelData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Bank</span>}
            rules={[
              {
                required: true,
                message: "Please select bank",
              },
            ]}
          >
            <Select
              name="jbbCode"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                bankBranch?.length > 0 &&
                bankBranch?.map((item) => ({
                  value: item?.jbbCode,
                  label: item?.jbbCode + " - " + item?.jbbBranchName,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "jbbCode");
              }}
              value={formData?.jbbCode}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchBankBranchData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Account No"
            rules={[
              {
                required: true,
                message: "Enter account number",
              },
            ]}
          >
            <Input
              name="sbAccountno"
              required
              value={formData?.sbAccountno}
              onChange={onChange}
              className="input"
            />
          </Form.Item>

          <Form.Item
            label="Pay Percentage"
            rules={[
              {
                required: true,
                message: "Enter pay percentage",
              },
            ]}
          >
            <InputNumber
              name="sbPaypercent"
              value={formData?.sbPaypercent}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "sbPaypercent")}
              className="input flex"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStaffBankModal;
